import { render, staticRenderFns } from "./DetailComplain.vue?vue&type=template&id=f1693e42&scoped=true"
import script from "./DetailComplain.vue?vue&type=script&lang=ts"
export * from "./DetailComplain.vue?vue&type=script&lang=ts"
import style0 from "./DetailComplain.vue?vue&type=style&index=0&id=f1693e42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1693e42",
  null
  
)

export default component.exports